module.exports = __webpack_public_path__ + "media/images/puzzle/puzzle_35-cc7090b91ee5599c87dc92d8a65e93e1.png";